"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4954],{

/***/ 43079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bo": function() { return /* binding */ NonObtbList; },
/* harmony export */   "aS": function() { return /* binding */ WtspModel; },
/* harmony export */   "lu": function() { return /* binding */ ObtbList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16310);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6154);






/**
 * Redirect to Google Maps with store location
 * @param {number} lat - latitude of the store
 * @param {number} lng - longitude of the store
 */ const redirectToGoogleMaps = (lat, lng)=>{
    const googleMapsUrl = "https://www.google.com/maps/dir/?api=1&destination=".concat(lat, ",").concat(lng);
    window.open(googleMapsUrl, "_blank");
};
const ObtbList = (param)=>{
    let { obtb , handleStoreDetailClicked , setModalIsOpen , all =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: obtb.length > 0 ? obtb === null || obtb === void 0 ? void 0 : obtb.map((store, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "obl_store_locator_col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "store_obl_logo",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/store_obl_logo_icon.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: store.business_name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "store_add_row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "store_add_text",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        children: store.address_1 ? store.address_1.replace("&amp;", "&") : ""
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: store.address_2 ? store.address_2.replace("&amp;", "&") : ""
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            store.city,
                                            ", ",
                                            store.state,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "add-sec",
                                        onClick: ()=>handleStoreDetailClicked(store),
                                        children: "More Details"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "store_add_icon",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "store-whatsapp-icon",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            onClick: ()=>setModalIsOpen(store),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                stroke: "green",
                                                fill: "green",
                                                "stroke-width": "0",
                                                viewBox: "0 0 448 512",
                                                height: "1em",
                                                width: "1em",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "store-duration-icon",
                                        onClick: ()=>redirectToGoogleMaps(store.lat, store.longt),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/duration.svg"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, index);
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: all == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "no-store-row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: "Oops!! No Store Found"
                })
            })
        })
    });
};
const NonObtbList = (param)=>{
    let { nonObtb , handleNonObtbClick , setModalIsOpen , all =false  } = param;
    return nonObtb === null || nonObtb === void 0 ? void 0 : nonObtb.map((store, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "obl_store_locator_col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: store.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "store_add_row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "store_add_text",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    children: store.address
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        store.city,
                                        ", ",
                                        store.state_desc
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "add-sec",
                                    onClick: ()=>handleNonObtbClick(store),
                                    children: "More Details"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "store_add_icon",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "store-whatsapp-icon",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        onClick: ()=>setModalIsOpen(store),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            stroke: "green",
                                            fill: "green",
                                            "stroke-width": "0",
                                            viewBox: "0 0 448 512",
                                            height: "1em",
                                            width: "1em",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "store-duration-icon",
                                    onClick: ()=>redirectToGoogleMaps(store.latitude, store.longitude),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/duration.svg",
                                        alt: "Duration Icon"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }, "nonObtb-".concat(index)));
};
const WtspModel = (param)=>{
    let { modalIsOpen , setModalIsOpen  } = param;
    // Yup validation schema
    const validationSchema = yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry({
        name: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required("Name is required"),
        phone: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required("Mobile Number is required"),
        city: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required("City is required"),
        message: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_()
    });
    // Initial values for Formik
    const initialValues = {
        name: "",
        phone: "",
        city: "",
        message: ""
    };
    const sendSms = async (values)=>{
        if (!modalIsOpen) {
            return;
        }
        let d1 = modalIsOpen.__typename === "Obtbs" ? modalIsOpen.business_name : modalIsOpen.name;
        let d2 = values.name;
        let d3 = values.city;
        let d4 = values.phone;
        let d5 = values.message;
        let U1 = values.name;
        let U2 = modalIsOpen.__typename === "Obtbs" ? modalIsOpen.business_name : modalIsOpen.name;
        let U3 = modalIsOpen.__typename === "Obtbs" ? "".concat(modalIsOpen.address_1 ? modalIsOpen.address_1 : "", ",").concat(modalIsOpen.address_2 ? modalIsOpen.address_2 : "", ",").concat(modalIsOpen.city ? modalIsOpen.city : "", ",").concat(modalIsOpen.state ? modalIsOpen.state : "", ",").concat(modalIsOpen.postcode ? modalIsOpen.postcode : "") : "".concat(modalIsOpen.address ? modalIsOpen.address : "", ",").concat(modalIsOpen.address_2 ? modalIsOpen.address_2 : "", ",").concat(modalIsOpen.city ? modalIsOpen.city : "", ",").concat(modalIsOpen.state_desc ? modalIsOpen.state_desc : "");
        let U4 = modalIsOpen.__typename === "Obtbs" ? modalIsOpen.main_phone_no : modalIsOpen.phone_no;
        let obj = {
            d1,
            d2,
            d3,
            d4,
            d5,
            U1,
            U2,
            U3,
            U4,
            userPhone: values.phone,
            dealerPhone: modalIsOpen.d_phone_no
        };
        try {
            const res = await axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("https://proxy.orientbell.com/send-storelocator-sms", obj);
            if (res.status === 200) {
                setModalIsOpen(false);
                swal("Thank you for your interest in our tiles. We have shared the requested store's details on your WhatsApp");
            } else {
                setModalIsOpen(false);
                swal("We are unable to send the address to your mobile, please try again later.");
            }
        } catch (error) {
            console.error("Error sending SMS:", error);
            swal("Something went wrong. Please try again later.");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        show: modalIsOpen,
        className: "pincode-popup-bx",
        onHide: ()=>setModalIsOpen(false),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Dialog */ .Z.Dialog, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Header */ .Z.Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Title */ .Z.Title, {
                        children: "Send this address on WhatsApp to me"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Formik */ .J9, {
                        initialValues: initialValues,
                        validationSchema: validationSchema,
                        onSubmit: (values, param)=>{
                            let { setSubmitting , resetForm  } = param;
                            sendSms(values);
                            setSubmitting(false);
                            resetForm();
                        },
                        children: (param)=>/*#__PURE__*/ {
                            let { isSubmitting  } = param;
                            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Form */ .l0, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Field */ .gN, {
                                        type: "text",
                                        name: "name"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                                        name: "name",
                                        component: "p",
                                        className: "error text-danger"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "Mobile Number"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Field */ .gN, {
                                        type: "number",
                                        name: "phone"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                                        name: "phone",
                                        component: "p",
                                        className: "error text-danger"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "City"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Field */ .gN, {
                                        type: "text",
                                        name: "city"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                                        name: "city",
                                        component: "p",
                                        className: "error text-danger"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "Message"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Field */ .gN, {
                                        type: "text",
                                        name: "message"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                                        name: "message",
                                        component: "p",
                                        className: "error text-danger"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        variant: "primary",
                                        type: "submit",
                                        disabled: isSubmitting,
                                        style: {
                                            width: "100%"
                                        },
                                        children: "Submit"
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86594);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31955);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63372);
// components/AddressAutocomplete.js







const AddressAutocomplete = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [selectedAddress, setSelectedAddress] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [getLocationLoading, setgetLocationLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, seterror] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleSelect = async (address)=>{
        setSelectedAddress(address);
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
            placeId: address.value.place_id
        }, async (results, status)=>{
            if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;
                let city = extractCityFromResults(results[0]);
                const lat = location.lat();
                const lng = location.lng();
                if (!city) {
                    const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(lat, "&lon=").concat(lng, "&format=json"));
                    const address = response.data.address;
                    city = address.state;
                }
                localStorage.removeItem("stateFromAdvancedSearch");
                localStorage.removeItem("cityFromAdvancedSearch");
                localStorage.setItem("cityFromSimpleSearch", city);
                localStorage.setItem("latitude", lat);
                localStorage.setItem("longitude", lng);
                // Redirect to the store locator with city in the URL
                router.push("/store-locator/".concat(city.toLowerCase().replace(/\s+/g, "-")));
                setSelectedAddress("");
            } else {
                console.error("Error fetching geocode data:", status);
            }
        });
    };
    // Extract city name from the address components
    const extractCityFromResults = (result)=>{
        const cityComponent = result.address_components.find((component)=>component.types.includes("locality") || component.types.includes("administrative_area_level_2"));
        return cityComponent ? cityComponent.long_name : "";
    };
    const retrieveGeolocation = async ()=>{
        try {
            const position = await new Promise((resolve, reject)=>{
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                });
            });
            if (!router.asPath.includes("/tiles")) {
                props.setLocationPopop(false);
                props.setleadpopop();
                setgetLocationLoading(false);
            }
            const { latitude , longitude  } = position.coords;
            const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(latitude, "&lon=").concat(longitude, "&format=json"));
            const address = response.data.address;
            if (address && address.postcode) {
                const pincode = address.postcode;
                props.setLocationPopop(false);
                props.setleadpopop();
                localStorage.setItem("pincodeSkip", true);
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode);
                (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                    pincodedetails: pincode
                });
                setgetLocationLoading(false);
                if (router.asPath.includes("/tiles")) {
                    router.reload();
                }
            }
        } catch (error) {
            console.error("Error retrieving location:", error);
            const errorMessage = error.message || "Something went wrong while retrieving your location.";
            swal(errorMessage);
        }
    };
    const extractPincodeFromResults = (result)=>{
        const postalCodeComponent = result.address_components.find((component)=>component.types.includes("postal_code"));
        return postalCodeComponent ? postalCodeComponent.short_name : "";
    };
    const renderSuggestions = (active, suggestions, onSelectSuggestion)=>{
        const filteredSuggestions = suggestions.filter((suggestion)=>{
            const hasPostalCode = suggestion.terms.some((term)=>term.types.includes("postal_code"));
            return hasPostalCode;
        });
        return filteredSuggestions.map((suggestion)=>{
            const isActive = active === suggestion.active;
            const classNames = "suggestion-item ".concat(isActive ? "active" : "");
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classNames,
                onClick: ()=>onSelectSuggestion(suggestion),
                children: suggestion.description
            }, suggestion.placeId);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                apiKey: "AIzaSyBrmlHMs5JUON_ErXHEKk_HSd2UoLN20HQ",
                autocompletionRequest: {
                    componentRestrictions: {
                        country: [
                            "in"
                        ]
                    }
                },
                selectProps: {
                    value: selectedAddress,
                    onChange: handleSelect,
                    placeholder: "Search for your city"
                },
                renderSuggestions: renderSuggestions
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "error text-danger",
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AddressAutocomplete);


/***/ })

}]);